'use client'
import {useEffect, useState} from 'react';
import styled from "styled-components";
import Title from "@/components/Title";
import {Black, White} from "@/styles/globalStyleVars";
import {Col, Container, Form, Row} from "react-bootstrap";
import Button from "@/components/Button";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {usePathname} from "next/navigation";
import Link from "next/link";
import axios from "axios";
import Cookies from "js-cookie";


const MyComponent = () => {


    const location = usePathname()
    const [isSubmitting, setIsSubmitting] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }, [])


    const {register, handleSubmit, formState, reset} = useForm({mode: 'all'});
    const {errors, isSubmitSuccessful} = formState;


    //--- form submit

    const success = (msg) => toast.success(msg, {
        position: "top-right", autoClose: 4000, closeOnClick: true, progress: undefined,
    });

    const error = (msg) => toast.error(msg, {
        position: "top-right", autoClose: 4000, closeOnClick: true, progress: undefined,
    });



    const onSubmit = async (data) => {
        setIsSubmitting(true); // Show spinner

        try {
            const formData = new FormData();
            formData.append('email', data?.email);

            const response = await axios.post('https://cms.ucbstock.com.bd//wp-json/custom/v1/forgot-password', formData);
            if (response.status === 200) {
                Cookies.set('user-token', response?.data?.token, { expires: 7 })
                Cookies.set('user-token-forget-mail', data?.email, { expires: 7 })
                success('OTP Send successfully')
                // window.location.href = 'http://localhost:3000/research/reset-password';
                window.location.href = '/research/reset-password';
                reset(); // Reset form fields
            } else {
                error('Failed to Login. Please check your username and password.');

            }
        } catch (err) {
            // error('Failed to submit form. Please try again later.');
        } finally {
            setIsSubmitting(false); // Hide spinner
        }
    };

    const onError = (errors) => {
        // setToastShown(false); // Reset toast shown state on new submission attempt
        const firstError = Object.values(errors)[0];
        error(firstError.message);
    };



    return (
        <StyledComponent className={'user pt-200 pb-200'}>
            <Container>
                <Row>
                    <Col sm={12}>
                        <Title margin={'0 0 60px 0'} color={"#191919"} text={'Forget Password'} number={'I'}/>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form onSubmit={handleSubmit(onSubmit, onError)}>

                            <Form.Group className={'from-group'}>
                                <Form.Control {...register('email', {
                                    required: {
                                        value: true,
                                        message: "Enter a valid email address"
                                    },
                                    pattern: {
                                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                        message: "Enter a valid email address"
                                    }
                                })} type="email*" placeholder="Email*"/>
                                <p className={'form-error'}>{errors.email?.message}</p>
                            </Form.Group>
                            <div style={{width: 'fit-content'}} onClick={handleSubmit(onSubmit, onError)}>
                                <Button
                                    submitButton
                                    margin={'60px 0 0 0'}
                                    text={'Submit'}/>
                            </div>
                        </Form>

                    </Col>
                </Row>

            </Container>

        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  //background-color: #08082B;
  background-color: #f4f4f4;

  //section {
  //  overflow: hidden;
  //  margin-bottom: -2px;
  //}

  .from-group {
      position: relative;
      .form-error {
          position: absolute;
          font-size: 10px;
          color: #EC1C23 !important;
          top: 100%;
      }
    margin-bottom: 25px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
    .form-control {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid #08082B;
        padding-left: 0;
        height: 45px;
        //margin-bottom: 25px;
        color: #191919;

        &:focus {
            border: none;
            border-bottom: 1px solid #191919 !important;
            border-color: #191919;
            outline: none;
            box-shadow: none;
        }

        &::placeholder {
            font-size: 15px;
            color: #191919;
        }
    }

  input:-webkit-autofill {
    -webkit-text-fill-color: ${Black} !important;
    border-bottom: 1px solid #26201E;

    &:hover {
      border-bottom: 1px solid #26201E !important;
    }

    &:focus {
      border-bottom: 1px solid #26201E !important;
    }
  }

  .user-alter {
    margin-top: 60px;

    p {
      color: #08082B;

      &:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }

    a {
      color: #ec1c24;
      text-decoration: underline;

      &:hover {
        color: #08082B !important;
      }
    }
  }



`;

export default MyComponent;
